import type { CoursesFragment } from 'Jsx/Shared/CourseCardV3/graphql/types/CoursesFragment';
import type { CourseRecommendedFragment } from 'Jsx/Shared/CourseCardV3/graphql/types/CourseRecommendedFragment';

export const COURSES_PAGE_SIZE = 12;

// @ts-expect-error
export const reduceById = (obj, item) => {
  obj[item.id] = { ...item, disabled: false };

  return obj;
};

const formatItemV2 = (
  buyUrl: string,
  item: CoursesFragment | CourseRecommendedFragment,
) => ({
  ...item,
  id: item.originalId,
  category: item.categoryObj,
  subcategory:
    // @ts-expect-error
    typeof item.subcategory === 'string'
      ? // @ts-expect-error
        { name: item.subcategory }
      : // @ts-expect-error
        item.subcategory,
  buyUrl,
  isEnrolled: item.isEnrollment,
});

export const formatCourseV2 = (
  course: CoursesFragment | CourseRecommendedFragment,
) => formatItemV2(`/shopping-cart/course/${course.originalId}/`, course);

export const checkIfisInShoppingCart =
  (courseIdsOwned: number[]) =>
  (course: CoursesFragment | CourseRecommendedFragment) => ({
    ...course,
    inShoppingCart: courseIdsOwned.some(id => id === course.originalId),
  });

const COURSE_FREE_REGEX =
  /\/?(ar|pe|es|us|bo|cr|co|cl|ec|mx)?\/cursos-gratis\/$/;

const pathnameCache = new Map<string, boolean>();

export const isCurrentPageCoursesFree = (pathname: string): boolean => {
  const cachedPathname = pathnameCache.get(pathname);

  if (cachedPathname === undefined) {
    const isCourseFree = COURSE_FREE_REGEX.test(pathname);

    pathnameCache.set(pathname, isCourseFree);

    return isCourseFree;
  }

  return cachedPathname;
};

export function getCursor(currentPage: number, pageSize: number): string {
  // in SSR return the page 0 in base64 (arrayconnection:0)
  if (typeof window === 'undefined') return 'YXJyYXljb25uZWN0aW9uOjA=';
  return btoa(`arrayconnection:${(currentPage - 1) * pageSize - 1}`);
}

/** @description Add a new item to array if it doesn't exist, or remove it if it does.  */
export function setItemToUniqueArray<T>(array: T[], itemId: T) {
  const list = array || [];
  const index = list.indexOf(itemId);

  if (index === -1) {
    list.push(itemId);
  } else {
    list.splice(index, 1);
  }

  return list;
}

export function orderArrayByNumberAttribute<T>(
  array: T[],
  attribute: keyof T,
  order: 'asc' | 'desc',
): T[] {
  return array.sort((a, b) => {
    const aValue = a[attribute];
    const bValue = b[attribute];

    if (order === 'asc') {
      // @ts-expect-error
      return aValue - bValue;
    }

    // @ts-expect-error
    return bValue - aValue;
  });
}
